export const headerStore = {
  title: ''
};

export interface IHeaderStore {
  title: string;
}
